import React, { Fragment } from 'react';
import axios from 'axios';
import moment from 'moment';
import { BarChart, XAxis, Tooltip, Bar, Cell, LabelList } from 'recharts';
import { Table, Header, Segment, Loader, Grid, Icon, Popup, Divider } from 'semantic-ui-react';
import { center, colorss as colors } from '../../Statistics/util';
import { FormattedMessage } from 'react-intl';
import SimpleTwoColumnTableRow from '../../StudentPersonalInfo/SimpleTwoColumnTableRow';
import { IconHeader } from '../ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const style = {
    top: 0,
    left: 350,
    lineHeight: '20px'
};

export default class ExamStatistic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true
        };
    }

    componentDidMount() {
        axios.get(`/exams/statistics/${this.props.location.state.gradedActivityId}`)
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        attention: (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) + '%',
                        passed: (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) + '%'
                    })),
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        const { data } = this.state;
        // if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <h1>Statistika </h1>
                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {this.props.location.state.courseImplementationName}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader><FormattedMessage id="professorStatistics.courseName" /></Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.tableShow" /></Header>
                                    </Divider>
                                    {/* <Segment.Group raised style={{ backgroundColor: 'white' }}> */}
                                    {/* <Segment clearing> */}
                                    {/*    <Header as="h3"> */}
                                    {/*        <FormattedMessage id="professorStatistics.tableShow" /> */}
                                    {/*    </Header> */}
                                    {/* </Segment> */}
                                    {/* {data.length ? <Segment> */}
                                    {/* <br /> */}
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        data.length ? <div><Table celled unstackable compact>
                                            <Table.Header>
                                                <Table.Row>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="common.course" />}
                                                    keyName="courseImplementation"
                                                    value={this.props.location.state.courseImplementationName}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.examType" />}
                                                    keyName="exam"
                                                    value={this.props.location.state.gradedActivityName}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.examOnlyDate" />}
                                                    keyName="date"
                                                    value={this.props.location.state.date}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.registration" />}
                                                    keyName="registration"
                                                    value={data[0].numberOfStudentsThatRegisteredExam}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.attention" />}
                                                    keyName="attention"
                                                    value={data[0].numberOfStudentsThatAttendedExam + ' (' + data[0].attention + ')'}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.passed" />}
                                                    keyName="passed"
                                                    value={data[0].numberOfStudentsThatPassedExam + ' (' + data[0].passed + ')'}
                                                />
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.averageGradeNew" />}
                                                    keyName="averageGrade"
                                                    value={Number(data[0].averageGrade).toFixed(2)}
                                                />
                                            </Table.Body>
                                        </Table>
                                        </div>
                                        // <br />
                                        //  </Segment>
                                            : <Segment>
                                                <FormattedMessage id="professorInputGrades.noDataForAcademicYear" />
                                            </Segment>}
                                    {/* </Segment.Group > */}
                                </Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4"><FormattedMessage id="professorStatistics.graphicShow" />
                                        </Header>
                                    </Divider>
                                    {/* <Segment.Group raised> */}
                                    {/*    <Segment> */}
                                    {/*        <Header as="h3"><FormattedMessage id="professorStatistics.graphicShow" /></Header> */}
                                    {/*    </Segment> */}
                                    {/* <Segment> */}
                                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                                        this.state.data.map((el) =>
                                            (
                                                <Fragment>
                                                    <BarChart
                                                        width={400}
                                                        height={210}
                                                        style={center}
                                                        margin={{ top: 20 }}

                                                        data={[
                                                            { name: 'prijave', 'broj studenata': el.numberOfStudentsThatRegisteredExam },
                                                            { name: 'izlaznost', 'broj studenata': el.numberOfStudentsThatAttendedExam },
                                                            { name: 'prolaznost', 'broj studenata': el.numberOfStudentsThatPassedExam },
                                                        ]}
                                                    >
                                                        <XAxis dataKey="name" />
                                                        <Tooltip />
                                                        <Bar
                                                            dataKey="broj studenata"
                                                            isAnimationActive
                                                        >
                                                            {
                                                                [1, 2, 3].map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={colors[index]} />
                                                                ))
                                                            }
                                                            <LabelList dataKey="broj studenata" position="top" fill="#001942" />
                                                        </Bar>
                                                    </BarChart>
                                                </Fragment>

                                            ))
                                        // </div>
                                    }
                                    {/* ///!* </Segment> *!/ */}

                                    {/* ///!* </Segment.Group> *!/ */}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorHistoryGrades/ExamStatistic.js